<template>
  <section class="services-section">
    <header>
      <slot name="header"/>
    </header>
    <main>
      <slot />
    </main>
  </section>
</template>

<script>
export default {
  name: 'Services',

  /**
   * The properties that the component accepts.
   */
  props: {
  },
};
</script>
